import { ChangeEvent, useRef, useState } from "react";
import { CommentCardProps } from "../ui/components/commentCard";

const ANIMATION_DURATION = 300;
export const MAX_MESSAGE_LENGTH = 500;

export const useComment = ({
  id,
  onReply,
  onDelete,
}: Partial<CommentCardProps>) => {
  const [isApproveOpen, setApproveOpen] = useState<boolean>(false);
  const [isReply, setReply] = useState<boolean>(false);
  const [content, setContent] = useState<string>("");
  const [deleteId, setDeleteId] = useState<string | null>(null);

  const textareaRef = useRef<HTMLDivElement | null>(null);

  const handleReply = () => {
    setReply(true);
    setTimeout(() => {
      textareaRef.current?.querySelector("textarea")?.focus();
    }, ANIMATION_DURATION);
  };

  const onChangeContent = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    setContent(raw.length <= 500 ? raw : raw.slice(0, 500));
  };

  const handleSubmit = () => {
    if (!id) return;
    onReply?.(id, content);
    setContent("");
    setReply(false);
  };

  const handleDeleteAnswer = (id: string) => {
    setApproveOpen(true);
    setDeleteId(id);
  };

  const handleDelete = () => {
    setApproveOpen(true);
  };

  const handleApproveClose = () => {
    setApproveOpen(false);
    setDeleteId(null);
  };

  const handleApprove = () => {
    if (!id) return;
    onDelete?.(deleteId ?? id);
    handleApproveClose();
    setDeleteId(null);
  };

  return {
    textareaRef,
    isApproveOpen,
    isReply,
    content,
    handleApprove,
    handleReply,
    handleDelete,
    handleDeleteAnswer,
    onChangeContent,
    handleSubmit,
    handleApproveClose,
    ANIMATION_DURATION,
  };
};
